require('new_design/common/search/index');
